import { type ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'
import { Icon, Link, Typography } from '@shc/ui'

import type { TypeProvider } from '@lib/types'
import NextImage from '@components/next-image'
import { PROVIDER_PLACEHOLDER_IMAGE_URL } from '@lib/constants'

export interface ProviderImageProps extends ComponentPropsWithoutRef<'div'> {
  provider: TypeProvider
  site?: 'public' | 'providers'
}

const ProviderImage = ({ provider, site='public', ...props }: ProviderImageProps) => {
  const hasVideo = !!provider.video_urls?.[0] && site === 'public';
  const providerPhotoUrl = provider.photo_url ?? PROVIDER_PLACEHOLDER_IMAGE_URL;

  return (
    <div {...props}>
      {hasVideo && (
        // IMAGE WITH VIDEO
        <Link noUnderline href="#provider-about">
          <div className="flex flex-col relative gap-2 justify-center">
            {/* provider image */}
            <div className="flex relative justify-center">
              <div className="h-[100px] w-[100px] flex items-center justify-center bg-gradient-to-r from-lightGradient to-darkGradient rounded-full relative lg:h-[150px] lg:w-[150px]">
                <NextImage
                  src={providerPhotoUrl}
                  alt="Provider Image"
                  className={clsx(
                    'object-cover w-[90px] h-[90px] lg:w-[135px] lg:h-[135px] rounded-full border-[3px] lg:border-[8px] border-gray-50'
                  )}
                  height={100}
                  width={150}
                />
              </div>

              {/* video icon */}
              <div className="h-[28px] w-[28px] lg:h-[36px] lg:w-[36px] bg-sharp-blue rounded-full flex items-center justify-center absolute bottom-0 right-0">
                <Icon className="text-white h-[12px] md:h-[16px]" icon="play" />
              </div>
            </div>
            {/* link text */}
            <Typography variant="small-body" as="div" className="flex justify-center font-bold">
              Watch&nbsp;video
            </Typography>
          </div>
        </Link>
      )}
      { !hasVideo && (
        // IMAGE WITH NO VIDEO
        <NextImage
          src={providerPhotoUrl}
          alt="Provider Image"
          className={clsx('w-[90px] h-[90px] lg:w-[135px] lg:h-[135px] rounded-full object-cover')}
          height={100}
          width={150}
        />
      )}
    </div>
  )
}

export default ProviderImage
